import React from "react";

const MarketingStats = ({ stats }) => {

    const cards = [

        {
            title: "Total Campaigns",
            value: stats.totalCampaigns || 0,
        },

        {
            title: "Running",
            value: stats.activeCampaigns || 0,
        },

        {
            title: "Scheduled",
            value: stats.scheduledCampaigns || 0,
        },

        {
            title: "Completed",
            value: stats.completedCampaigns || 0,
        },

    ];

    return (

        <div className="marketing-stats">

            {

                cards.map(card => (

                    <div
                        className="marketing-card"
                        key={card.title}
                    >

                        <h4>{card.title}</h4>

                        <h2>{card.value}</h2>

                    </div>

                ))

            }

        </div>

    );

};

export default MarketingStats;